import React from 'react';
import { Body, Box, BoxProps, Icon } from '@hover/blueprint';
import { iLayout } from '@hover/icons';
import NewsLetterLink from './NewsLetterLink';
import { HOVER_COMMUNITY_LINK } from '../../../constants';

interface Props extends BoxProps {
  iconColor: string;
}

const NewsLetterJoinCommunity: React.FC<Props> = ({
  iconColor,
  ...restProps
}) => (
  <Box flex={1} flexDir="column" alignItems="flex-start" {...restProps}>
    <Icon m={0} icon={iLayout} color={iconColor} size="large" />
    <Body color="neutral.0" size={500} isBold pt={500} pb={400}>
      JOIN OUR ONLINE COMMUNITY
    </Body>
    <Body width="90%" color="neutral.0" size={500} pb={500}>
      Join our online forum with hundreds of homeowners and pros to learn about
      anything home improvement.
    </Body>
    <NewsLetterLink to={HOVER_COMMUNITY_LINK} title="Join for free" />
  </Box>
);

export default NewsLetterJoinCommunity;
